import includes from 'lodash/includes'
import React from 'react'
import type { IconProps } from './index'

export const BootstrapIcon = ({ className, name, title }: IconProps) => {
  className = className || ''

  const isBasicIcon = React.useMemo(() => {
    //if hte name contains fa-, then is the Icon, else use the <i/>
    return !includes(name, 'bi-')
  }, [name])

  return isBasicIcon ? <i className={`bi bi-${name} ${className}`} title={title} /> : <i className={name} />
}
